import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { SiteContentProvider } from "@/context/SiteContent";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalPage from "@/pages/LegalPage";

// Jeder Seitenwechsel startet oben (auch mit Lenis-Smooth-Scroll)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import VertragPage from "@/pages/VertragPage";
import RechnungPage from "@/pages/RechnungPage";
import BuchungPage from "@/pages/BuchungPage";
import WebsiteBookingPage from "@/pages/WebsiteBookingPage";
import WebsiteOrderPage from "@/pages/WebsiteOrderPage";

export default function App() {
  return (
    <SiteContentProvider>
    <BrowserRouter>
      <div className="grain-overlay" aria-hidden="true" />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/impressum" element={<LegalPage page="impressum" />} />
        <Route path="/datenschutz" element={<LegalPage page="datenschutz" />} />
        <Route path="/agb" element={<LegalPage page="agb" />} />
        <Route path="/vertrag/:id" element={<VertragPage />} />
        <Route path="/rechnung/:id" element={<RechnungPage />} />
        <Route path="/buchen/:service" element={<Navigate to="/" replace />} />
        <Route path="/buchen/website" element={<WebsiteBookingPage />} />
        <Route path="/website-bestellung/:id" element={<WebsiteOrderPage />} />
        <Route path="/buchung/:id" element={<BuchungPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        {/* alter Geheim-Pfad leitet auf den regulären Admin um */}
        <Route path="/jh-buero" element={<Navigate to="/admin" replace />} />
        <Route path="/jh-buero/login" element={<Navigate to="/admin/login" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #27272a",
            color: "#f4f3ef",
            borderRadius: "2px",
          },
        }}
      />
    </BrowserRouter>
    </SiteContentProvider>
  );
}
